import moment from "moment";

export function fromUTC(utc: number): moment.Moment {
  return moment.unix(utc);
}

export function toUTC(date: moment.Moment): number {
  return date.unix();
}
